import React from "react";
import styled, { css } from "styled-components";
import { footerLogos } from "../sections/Home/components/constant";
// Images
import Authenticating from "../images/logos/Logo_light.svg";
import LogoTooltip from "./reusable/LogoTooltip";

const MainFooter = styled.footer`
	width: 100%;
	background: #001225;
	color: #fff;
	padding-bottom: 100px;

	@media screen and (max-width: 500px) {
		padding-bottom: 70px;
	}
`;

const FooterGrid = styled.div`
	max-width: 1280px;
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	padding: 44px 20px;

	@media screen and (max-width: 820px) {
		grid-template-columns: 100%;
		grid-template-rows: 50% 50%;
	}
`;

const CopyrightSection = styled.div`
	margin-bottom: 0;
`;

const LinksSection = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	padding: 0 24px;

	@media screen and (max-width: 820px) {
		padding: 0;
		margin-top: 20px;
	}

	@media screen and (max-width: 500px) {
		padding: 0;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: 1fr 1fr;
		gap: 1.5rem;
	}
`;

const LinkGrid = styled.div``;

const Logo = styled.img`
	width: auto;
	height: 45px;

	${({ brandLogo }) =>
		brandLogo &&
		css`
			width: 144px;
			height: 16px;
		`};
`;

const Heading = styled.h1`
	font-size: 18px;
	font-weight: 500;
`;

const SubText = styled.p`
	font-size: 14px;
	color: ${(props) =>
		props.copyright ? "#EFF8FF" : "rgba(255, 255, 255, 0.8)"};
	margin-top: ${({ marginTop }) => marginTop};

	${({ disclaimer }) =>
		disclaimer &&
		css`
			font-size: 10px;
			color: rgba(255, 255, 255, 0.8);
			margin-top: 16px;
			width: 60%;
		`};

	@media screen and (max-width: 768px) {
		width: 80%;

		${({ disclaimer }) =>
			disclaimer &&
			css`
				font-size: 12px;
			`};
	}
`;

const NavLinks = styled.a`
	text-decoration: none;
	color: rgba(255, 255, 255, 0.8);
	display: block;
	font-size: 14px;
	margin: ${(props) => (props.logos ? "0" : "12px 0")};
`;

const LogoContainer = styled.div`
	margin-top: 24px;
	display: flex;
	gap: 24px;
	flex-wrap: wrap;
`;

function Footer() {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();

	return (
		<MainFooter>
			<FooterGrid>
				<CopyrightSection>
					<Logo
						brandLogo
						src={Authenticating}
						alt="Authenticating.com"
						width="auto"
						height="auto"
						loading="lazy"
					/>
					<SubText copyright marginTop="8px">
						{`Copyright © ${currentYear} Authenticating.com LLC. All rights reserved.`}
					</SubText>
					<SubText disclaimer>
						Disclaimer : Authenticating.com LLC d/b/a Authenticate, is not
						a consumer reporting agency & its service does not constitute
						"consumer reporting" as such term is defined in the federal
						Fair Credit Reporting Act (FCRA), 15 U.S.C.A. sec 1681 et seq.
						The data provided from this service may not be used as a
						factor in establishing a consumer's eligibility for credit,
						insurance, employment or for any other purpose in the FCRA &
						you agree not to use this service for such a purpose or to
						take adverse action regarding any consumer application based
						on this service.
					</SubText>
					<LogoContainer>
						{footerLogos.map((logo) => (
							<NavLinks
								logos
								target="_blank"
								rel="noreferrer"
								href={logo.link}
								key={logo.id}
							>
								{logo.tooltipText ? (
									<LogoTooltip content={logo.tooltipText}>
										<Logo
											src={logo.logo}
											alt={logo.name}
											margin
											width="auto"
											height="auto"
											loading="lazy"
										/>
									</LogoTooltip>
								) : (
									<Logo
										src={logo.logo}
										alt={logo.name}
										margin
										width="auto"
										height="auto"
										loading="lazy"
									/>
								)}
							</NavLinks>
						))}
					</LogoContainer>
				</CopyrightSection>
				<LinksSection>
					<LinkGrid>
						<Heading>Navigation</Heading>
						<NavLinks href="/#solution">Solution</NavLinks>
						<NavLinks href="/#pricing">Pricing</NavLinks>
						<NavLinks href="/#contact">Contact</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="https://docs.authenticating.com/"
						>
							Documentation
						</NavLinks>
						<NavLinks href="/resources/blog">Resources</NavLinks>
					</LinkGrid>
					<LinkGrid>
						<Heading>Links</Heading>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="/terms-of-use"
						>
							{" "}
							Terms of Use
						</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="/privacy-policy"
						>
							Privacy Policy
						</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="https://portal.authenticating.com/register"
						>
							Get Started
						</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="https://portal.authenticating.com"
						>
							Log in
						</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="https://verify.authenticating.com/onboarding"
						>
							Medallion™
						</NavLinks>
						<NavLinks
							target="_blank"
							rel="noreferrer"
							href="https://statuspage.freshping.io/48329-Authenticating"
						>
							System Status
						</NavLinks>
						<NavLinks href="#demo">Request a Demo</NavLinks>
					</LinkGrid>
					<LinkGrid>
						<Heading>Contact</Heading>
						<SubText marginTop="10px">
							<NavLinks href="mailto:info@authenticate.com">
								Email: <br />
								info@authenticate.com
							</NavLinks>
						</SubText>
						<SubText marginTop="10px">
							Toll Free: <br /> (833) 2-VERIFY
						</SubText>
						<SubText marginTop="10px">
							730 Arizona Avenue, Suite 230, Santa Monica, CA 90401
						</SubText>
					</LinkGrid>
				</LinksSection>
			</FooterGrid>
		</MainFooter>
	);
}

export default Footer;
